module.exports = __webpack_public_path__ + "img/styles-light-thumb.b734e4ab.png";